module.exports = __webpack_public_path__ + "5c57861ea09fcf694c68ab5ff192b42a.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/call_your_elites-768.webp.png
// module id = 209
// module chunks = 0